import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgReturn32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M14.777 16.084a.5.5 0 1 1-.554.832l-6-4a.543.543 0 0 1-.04-.03l-.005-.004-.003-.002-.023-.02-.011-.012-.016-.018a.667.667 0 0 1-.02-.023l.02.023a.496.496 0 0 1-.123-.282l-.001-.024L8 12.5a.498.498 0 0 1 .046-.21l.018-.036a.5.5 0 0 1 .008-.013l-.026.05a.498.498 0 0 1 .079-.121l.016-.018.011-.011.018-.016.013-.012-.013.012a.496.496 0 0 1 .05-.04l.003-.001 6-4a.5.5 0 0 1 .625.775l-.07.057L10.15 12H19a6 6 0 0 1 5.996 5.775L25 18a6 6 0 0 1-6 6H9a.5.5 0 1 1 0-1h10a5 5 0 0 0 0-10h-8.848z" className="return-32_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgReturn32);
export default Memo;